import {useContext} from 'react';
import {StoreContext} from '@roc/feature-app-core';
import {UploadLeadsStore} from '../stores'

export const useUploadLeadsStore=() => useContext<{
  uploadLeadsStore: UploadLeadsStore
}>(StoreContext);
